/**
 * L2-S5: moved to @miq/platform-ui (components/filters-bar/filters-bar.component.ts). This shim keeps the old
 * import path working; new code should import from '@miq/platform-ui'.
 */
export { FiltersBarComponent } from '@miq/platform-ui';
